import LandingBgImg from './assets/landing-bg.png'
// import FanyNbImg from './assets/fany-nb.png'
// import FanyColorImg from './assets/fany-color.png'
import FanySingle from './assets/fany-single.webp'

import ByconceptThumb from './assets/byconcept-thumb.webp'
import SubwayThumb from './assets/subway-thumb.jpg'
import ProtectionThumb from './assets/protection-thumb.jpg'
import PassionThumb from './assets/passion-thumb.jpg'
import HypnoseThumb from './assets/hypnose-thumb.jpg'
import IllusThumb from './assets/illus-thumb.webp'
import RealeaseThumb from './assets/realease-thumb.jpg'
import OrganilogThumb from './assets/organilog-thumb.jpg'
import DecidocThumb from './assets/decidoc-thumb.jpg'
import HistoireThumb from './assets/histoire-thumb.jpg'
import DentaireThumb from './assets/dentaire-thumb.jpg'
import MamanvogueThumb from './assets/mamanvogue-thumb.webp'
import AlpagaThumb from './assets/alpaga-thumb.jpg'

export default {
  // fanyNb: FanyNbImg,
  // fanyColor: FanyColorImg,
  fanySingle: FanySingle,
  landingBg: LandingBgImg,
  works: [
    {
      caption: 'By Concept',
      src: ByconceptThumb,
      path: '/work/byconcept/',
    },
    {
      caption: 'Subway',
      src: SubwayThumb,
      path: '/work/subway/',
    },
    {
      caption: 'Protection 24',
      src: ProtectionThumb,
      path: '/work/protection/',
    },
    {
      caption: `Nantes Passion`,
      src: PassionThumb,
      path: '/work/passion/',
    },
    {
      caption: `Nantes Hypnose`,
      src: HypnoseThumb,
      path: '/work/hypnose/',
    },
    {
      caption: 'Illustrations',
      src: IllusThumb,
      path: '/work/illus/',
    },
    {
      caption: 'Realease Capital',
      src: RealeaseThumb,
      path: '/work/realease/',
    },
    {
      caption: 'Organilog',
      src: OrganilogThumb,
      path: '/work/organilog/',
    },
    {
      caption: `Decidoc`,
      src: DecidocThumb,
      path: '/work/decidoc/',
    },
    {
      caption: `Museum d'Histoire Naturelle Nantes`,
      src: HistoireThumb,
      path: '/work/histoire/',
    },
    {
      caption: `Information Dentaire`,
      src: DentaireThumb,
      path: '/work/dentaire/',
    },
    {
      caption: 'Maman Vogue',
      src: MamanvogueThumb,
      path: '/work/mamanvogue/',
    },
    {
      caption: 'Quatre mille chic alpaga',
      src: AlpagaThumb,
      path: '/work/alpaga/',
    },
  ],
}



// WEBPACK FOOTER //
// ./src/home-data.js